class AddEditBrandModalController {
    constructor($window, UtpBrandServiceApi, toastr) {
        this.$onInit = () => {
            this.init();
        };
        this.cancel = () => {
            this.dismiss({ $value: 'Cancel' });
        };
        this.closeModal = () => {
            this.close({ $value: this.state.action });
        };
        this.ok = () => {
            if (this.data.brand.Name === this.data.newName &&
                this.data.newName !== '') {
                this.cancel();
                return;
            }
            if (this.data.newName === '') {
                this.toastr.error('Brand name cannont be blank.');
            }
            else {
                this.data.brand.Name = this.data.newName;
                this.UtpBrandServiceApi.saveBrand(this.data.brand).then((response) => {
                    // ensure we have a response
                    let addUpdateResult = response.data;
                    if (!angular.isUndefined(addUpdateResult)) {
                        // If there are errors, then act
                        if (addUpdateResult.errors.length > 0) {
                            this.validationErrors = addUpdateResult.errors;
                            angular.forEach(this.validationErrors, (validationError) => {
                                this.toastr.error(validationError);
                            });
                            return;
                        }
                        // Brand Updated Added and now we close the modal.
                        this.close({ $value: this.state.action });
                    }
                    else {
                        // should never happen but may cause issues when we hang the timeout during debugging
                        // this will handle the case where users experience a slow response and the timeout is hit.
                        this.toastr.info('Error saving details please double check all mandatory fields are completed.');
                        this.cancel();
                    }
                });
            }
        };
        this.init = () => {
            this.state = {
                action: 'Create'
            };
            this.data = {
                brand: null,
                newName: ''
            };
            let params = this.resolve;
            this.brand = params.brand;
            this.data.brand = this.brand;
            this.data.newName = this.brand.Name;
            if (!this.brand) {
                this.toastr.warning('You must supply a valid brand parameter');
            }
            if (this.brand.Id > 0) {
                this.state.action = 'Update';
            }
            return;
        };
        this.window = $window;
        this.UtpBrandServiceApi = UtpBrandServiceApi;
        this.toastr = toastr;
    }
}
angular.module('app').component('addEditBrandModalComponent', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/Brand/add-edit-brand.tpl.html',
    controllerAs: 'vm',
    controller: AddEditBrandModalController
});
